import styled from "styled-components/macro"

export const Container = styled.div`
  padding: 12px 24px;
  background-color: white;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Paragraph = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSizeTextMedium};
  font-style: italic;
  margin: 0;
`
